import * as React from "react";
import {Component} from "react";
import styled from "react-emotion";

interface ISentimentProps {
    data: any;
}

interface ISentimentState {
    date: string;
    activity: number;
    avg7Days: number;
    avg14Days: number;
    avg30Days: number;
    negativeScore: number;
    positiveScore: number;
    score: number;
}

const Container = styled("div")`
  :hover {
    color: black;
    background-color: #ebf1fa;
  }
`;

const Heading = styled("div")`
  margin-left: 5px;
  font-weight: 700;
`;

const Content = styled("div")`
  text-align: left;
  margin-left: 15px;
  font-size: 14px;
  display: flex;
`;

const DataLabel = styled("div")`
  width: 150px;
  color: black;
  text-align: right;
  margin-right: 5px;
`;

const DataValue = styled("div")`
  flex: 1;
  text-align: left;
  margin-left: 5px;
`;

class SocialSentimentResult extends Component<ISentimentProps, ISentimentState> {

    public constructor(props: ISentimentProps) {
        super(props);

        const data = props.data;

        this.state = {
            date: data.date,
            activity: data.activity,
            avg7Days: data.avg_7_days,
            avg14Days: data.avg_14_days,
            avg30Days: data.avg_30_days,
            negativeScore: data.negative_score,
            positiveScore: data.positive_score,
            score: data.score
        };
    }

    public render() {
        return <React.Fragment>
            <Container>
                <Heading>{this.state.date}</Heading>
                <Content>
                    <DataLabel>Score:</DataLabel><DataValue>{this.state.score}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Positive Score:</DataLabel><DataValue>{this.state.positiveScore}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Negative Score:</DataLabel><DataValue>{this.state.negativeScore}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Avg. 7 Days:</DataLabel><DataValue>{this.state.avg7Days}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Avg. 14 Days:</DataLabel><DataValue>{this.state.avg14Days}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Avg. 30 Days:</DataLabel><DataValue>{this.state.avg30Days}</DataValue>
                </Content>
                <Content>
                    <DataLabel>Activity:</DataLabel><DataValue>{this.state.activity}</DataValue>
                </Content>
            </Container>
        </React.Fragment>;
    }
}

export default SocialSentimentResult;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/SocialSentiment/SocialSentimentResult.tsx